import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_process_instance_hdr_RowInterface {
  guid: string;
  job_order_hdr_guid: string;
  process_guid: string;
  machine_guid: string;
  duration: number;
  branch_guid: string;
  location_guid: string;
  process_status: string;
  start_date: string;
  end_date: string;
  posting_inventory: string;
  posting_journal: string;
  posting_running_no: string;
  created_date: string;
  updated_date: string;
  instance_type: string;
  name: string;
  code: string;
  descr: string;
  namespace: string;
  applet_guid: string;
  module_guid: string;
  acl_config: any;
  acl_policy: any;
  property_json: any;
  status: string;
  revision: string;
  vrsn: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  process_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  is_active: boolean;
  uom: string;
  output_inv_item_guid: fromDatatype.GuidDataFieldInterface;
  priority: number;
  sequence_no: number;
  parent_guid: string;
  process_type_code: string;
  customer_guid: string;
  supplier_guid: string;
  process_group_guid: string;
  connecting_option_link: string;
  posting_status: string;
}

export class bl_mrp_process_instance_hdr_RowClass implements bl_mrp_process_instance_hdr_RowInterface {
  guid: string;
  job_order_hdr_guid: string;
  process_guid: string;
  machine_guid: string;
  duration: number;
  branch_guid: string;
  location_guid: string;
  process_status: string;
  start_date: string;
  end_date: string;
  posting_inventory: string;
  posting_journal: string;
  posting_running_no: string;
  created_date: string;
  updated_date: string;
  instance_type: string;
  name: string;
  code: string;
  descr: string;
  namespace: string;
  applet_guid: string;
  module_guid: string;
  acl_config: any;
  acl_policy: any;
  property_json: any;
  status: string;
  revision: string;
  vrsn: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
  process_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  is_active: boolean;
  uom: string;
  output_inv_item_guid: fromDatatype.GuidDataFieldInterface;
  priority: number;
  sequence_no: number;
  parent_guid: string;
  process_type_code: string;
  customer_guid: string;
  supplier_guid: string;
  process_group_guid: string;
  connecting_option_link: string;
  posting_status: string;
}
